<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        stateOptions: [],
        statusOptions: [],
        form: [
          { // 车牌号码
            label: '车牌号码',
            value: 'customerCode',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 司机姓名
            label: '司机姓名',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          { // 司机电话
            label: '司机电话',
            value: 'state',
            type: 'input',
            placeholder: '请选择司机电话',
          },
          { // 名单类型
            label: '名单类型',
            value: 'status',
            type: 'select',
            placeholder: '请选择名单类型',
          },
          { // 状态
            label: '状态',
            value: 'state',
            type: 'select',
            placeholder: '请选择状态',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SYS_STATE_DESC,CUSTOMER_AUTH_STATE',
    });
    this.searchBoxData.stateOptions = enumsList[0];
    this.searchBoxData.statusOptions = enumsList[1];
  },
};
</script>

<style lang="scss" scoped>
</style>
